export const GET_CLIENT_NOTIFICATION_SUCCESS = "GET_CLIENT_NOTIFICATION_SUCCESS";
export const ADD_CLIENT_NOTIFICATION_SUCCESS = "ADD_CLIENT_NOTIFICATION_SUCCESS";
export const UPDATE_CLIENT_NOTIFICATION_SUCCESS = "UPDATE_CLIENT_NOTIFICATION_SUCCESS";
export const ENABLE_CLIENT_NOTIFICATION_SUCCESS = "ENABLE_CLIENT_NOTIFICATION_SUCCESS";
export const DISABLE_CLIENT_NOTIFICATION_SUCCESS = "DISABLE_CLIENT_NOTIFICATION_SUCCESS";
export const RESET_CLIENT_NOTIFICATION_SUCCESS = "RESET_CLIENT_NOTIFICATION_SUCCESS";
